module.exports = __webpack_public_path__ + "images/sales-voumes-9dc99913.svg";